<div class="kt-form" [ngClass]="{'readonly': readonly}">
    <kt-filter-section-all
        [acType]="targetProperty.generalInfo.propertySubTypeId"
        [filter$]="filter$"
        [showFilters]="showMap"
        (filterChange)="onFilterChange($event)"
        ></kt-filter-section-all>
    <div class="form-group kt-form-group row" [class.map-offscreen]="!showMap">
        <div class="col-lg-12 kt-margin-bottom-10-mobile">
            <p style="text-align: end !important;">
                Total showing comparables: {{comparablesCount$|async}}
            </p>
        </div>
        <div class="col-lg-12 md-2">
            <agm-map
                [latitude]="latitude"
                [longitude]="longitude"
                [zoom]="15"
                [disableDoubleClickZoom]="true"
                (mapReady)="onMapReady($event)"
                (zoomChange)="onZoomChanged($event)"
                (boundsChange)="onBoundsChanged($event)"
            >
                <agm-map-type-control></agm-map-type-control>
                <button type="button" id="Profile" class="btn btn-light btn-icon mr-2 map-button">
                    <mat-icon>my_location</mat-icon>
                </button>
                <agm-marker
                    [latitude]="targetProperty.generalInfo.locationData.latitude"
                    [longitude]="targetProperty.generalInfo.locationData.longitude"
                    [iconUrl]="tpIcon"
                    animation="DROP"
                ></agm-marker>
                <!--
                    The comparable markers are not declared here. They are drawn and
                    clustered imperatively by ComparableMarkerLayer, from onMapReady: a
                    component per pin is most of what a viewport of comparables costs, and
                    picking one in the table used to rebuild every marker on the map. The
                    target property's own pin stays declarative, above -- it is never
                    clustered and never changes.
                -->
            </agm-map>
        </div>
    </div>
</div>